import { Component, OnInit, ElementRef, ChangeDetectorRef, ViewChild, Inject } from '@angular/core';
import { Constants } from '../../utils/constants';
import { formatDate } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { BankProfile } from '../../../components/utils/bank-profile';
import { HttpService } from '../../../components/service/http.service';
import { BankDetailService } from '../../../components/service/bank-detail.service';
import { Router } from '@angular/router';
import { TruckAccountInfo } from '../../../components/utils/truck-account-info';
import { PaymentPayload } from '../../../components/utils/payload';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AssetListResponse } from '../../../shared/models/assetListResponse';
import { PayoffResponseBeanList } from '../../../shared/payoffResponseBeanList';
import { ContractNumberRequest } from '../../../shared/models/contractNumberResponse';
import { AuthorizationService } from '../../authorization/authorization.service';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../../utils/sharedTranslateModule';
import { Banner } from '../../../shared/models/banner';
import { DTFHomepageService } from '../../dtfhomepage/dtfhomepage.service';

import {MatDatepickerModule} from '@angular/material/datepicker';
import { PayComponent } from '../../pay/pay.component';
import { MatIconModule } from '@angular/material/icon';
import { monthlypaymentResponseList } from '../../../shared/models/monthlypaymentResponseList';
import { PayCopyComponent } from '../../pay copy/paycopy.component';
import { WindowRef } from '../../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { PayoffDialogComponent } from '../../payoff/payoff.component';
import { MatRadioModule } from '@angular/material/radio';
import { principalPaymentResponseList } from '../../../shared/models/principalPaymentResponseList';
import { AuthorizeDialogComponent } from '../onlinepayment/onlinepayment.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { AgreementDetailsList } from '../../../shared/models/AgreementDetailsList';
import { MatButtonModule } from '@angular/material/button';
import { provideNativeDateAdapter } from '@angular/material/core';
import { forkJoin } from 'rxjs';
import { monthlypaymentRequestlist } from '../../../../../src/app/shared/models/monthlypaymentRequestlist';
import { executionInterval } from '../../../../../src/app/shared/models/executionInterval';
import { SubscriptionResponseList } from '../../../../../src/app/shared/models/SubscriptionResponseList';
import { Daum } from '../../../../../src/app/shared/models/Daum';
import { CancelSubscriptionResponse } from '../../../../../src/app/shared/models/CancelSubscriptionResponse';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SessionTimeoutComponent } from '../../sessionTimeout/sessionTimeout.component';

interface Status {
  value: string;
  viewValue: string;
}

interface Payments {
  value: string;
  viewValue: string;
}

interface Requests {
  value: string;
  viewValue: string;
}

export enum ToggleEnum { //used for mat toggle
  Option0,
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
  Option8,
  Option9,
}

@Component({
    selector: 'div.dtf-scheduledpayment',
    templateUrl: './scheduledpayment.component.html',
    styles: [],
    providers: [],
    imports: [SharedTranslateModule,SessionTimeoutComponent,
        MatPaginator, MatSort, MatTableModule, MatInputModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule, MatSortModule, MatIconModule, MatRadioModule
    ]
})
export class ScheduledpaymentComponent implements OnInit {


  isCheckedRegular: boolean
  isCheckedPrincipal: boolean
  step1DisplayedColumns = ['select', 'amount', 'startDate', 'endDate']
  step2DisplayedColumns = ['Account', 'recurringPaymentAmount', 'recurringStartDate', 'recurringEndDate', 'transacationId', 'status']
  statuses: Status[] = [
    { value: 'active', viewValue: 'ACTIVE' },
    { value: 'expired', viewValue: 'EXPIRED' },
    { value: 'cancel', viewValue: 'CANCELLED' },
  ];
  selectedPayments: Payments[] = [
    {value: 'make payments', viewValue: 'Make a Payment'},
    {value: 'principal payments', viewValue: 'Principal Payment'},
    {value: 'recurring payments', viewValue: 'Recurring Payment'},
    {value: 'statement payments', viewValue: 'Statement Payment'},
    {value: 'payment history', viewValue: 'Payment History'},
    {value: 'manage profile', viewValue: 'Manage Bank Profile'},
    
  ];

  dropDownList: Array<any>=[];
  paymentType: string;
  Authorize: any;
  AuthorizeBoolean: boolean;
  bankDetailObj: BankProfile = new BankProfile;
  selected: any;
  profiles: any;
  loaded: boolean;
  accountList: TruckAccountInfo[];
  userAccountInfo:any
  agentView: boolean;
  page: string;
  blocked: boolean;
  errmsg: any;
  isFrench = false;
  language = '';
  assetListRes: AssetListResponse[]; 
  titleAuthNumberList: ContractNumberRequest[];
  token: string;
  rowCount = 0;
  ciamId = sessionStorage.getItem('loginID');
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  terminationDate ='';
  brandId: string;
  selection = new SelectionModel<monthlypaymentResponseList>(true, []);
  selectionsingle = new SelectionModel<monthlypaymentResponseList>(false, []);
  currentCountry: string;
  dbData: any;
  langFlag: string;
  countryFlag: string;
  bodyLoaded = false;
  thirdParty: string;
  tableLoaded = true;
  selectedRecurringResponseList: monthlypaymentResponseList[];
  accountSelected = false;
  customerName: string;
  invalidR: boolean=false;
  invaliddate = false;
  minDate: Date;
  maxDate: Date;
  azURL: string;
  usUrl: string;
  trans_history = false;
  isChecked = false;
  required = false;
  amount = false;
  selectone = false;
  currentDate: Date;
  scheduledpayment = true;
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option0;
  accountNumbers = [];
  Editamount = [];
  edate = [];
  agreementDetailsList: AgreementDetailsList[];
  dtpayCustomerId: String = "";
  dtpayPaymentMethodToken: String = '';
  lineitemsList: monthlypaymentRequestlist;
  line_items: monthlypaymentRequestlist[];
  reference: string;
  status: string;
  executionInterval: executionInterval;
  exec_Interval: executionInterval[];
  subscriptionResponseList: SubscriptionResponseList[];
  step1 = true;
  regularpayment = false;
  subscriptionList: Daum[];
  selectedHistoricalResponseList: Daum[];
  CancelSubscriptionSuccess = false;
  showerror = false;
  CancelSubscriptionData: CancelSubscriptionResponse[];
  Cancelid: string;
  selectedDateRange: { start: Date | null; end: Date | null } = { start: null, end: null };
  duplicateAgreementNumbers: string[] = [];
  firstDoRegularPayment = false;
  warningMessage: string = '';
  showWarning = false;
  agentview: string;
  failureError = false;

 

  initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: 'select'
    },
    {
      name: 'line_items[0].description',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'line_items[0].unit_price',
      display: 'Payment Amount',
      dispFormat: 'paymentamount'
    },
    {
      name: 'execution_interval.start_date',
      display: 'Start Date',
      dispFormat: 'date1'
    },
    {
      name: 'execution_interval.end_date',
      display: 'End Date',
      dispFormat: 'date2'
    },
    {
      name: 'reference',
      display: 'Transaction Id',
      dispFormat: 'transaction'
    },
    {
      name: 'status',
      display: 'Status',
      dispFormat: 'status'
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  CancelSubinitColumns: any[] = [
    {
      name: 'line_items[0].description',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'calculated_amounts.gross_order_total',
      display: 'Payment Amount',
      dispFormat: 'paymentamount'
    },
    {
      name: 'execution_interval.start_date',
      display: 'Start Date',
      dispFormat: 'date1'
    },
    {
      name: 'execution_interval.end_date',
      display: 'End Date',
      dispFormat: 'date2'
    },
     {
      name: 'reference',
      display: 'Transaction Id',
      dispFormat: 'transaction'
    },
    {
      name: 'status',
      display: 'Status',
      dispFormat: 'status'
    }
  ];
  displayedColumnsCancelSub: any[] = this.CancelSubinitColumns.map(col => col.name);


 

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  selectionHis = new SelectionModel<Daum>(true, []);
  subscriptionDataSource: MatTableDataSource<SubscriptionResponseList>;
  HistoricalSubscriptionDataSource: MatTableDataSource<Daum>;
  CancelSubscriptionDataSource: MatTableDataSource<CancelSubscriptionResponse>;


  constructor(private cdr: ChangeDetectorRef, private router: Router, private httpService: HttpService, private bankDetailService: BankDetailService, public auth: AuthorizationService,private dtfhomepageService: DTFHomepageService, private _window: WindowRef, public translate: TranslateService, public dialog: MatDialog) {
    this.subscriptionResponseList = [];
    this.subscriptionList = [];
    this.selectedHistoricalResponseList = [];
    this.agreementDetailsList = [];
    this.CancelSubscriptionData = [];
    this.line_items = [];
    this.exec_Interval = [];
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.minDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+1);
    this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
   }

  ngOnInit(): void {
    this.subscriptionsList();
    this.customerName = sessionStorage.getItem('customerName');
    this.thirdParty = sessionStorage.getItem('thirdPartyNumber');
    this.onLoad();
    this.token = sessionStorage.getItem('ciamToken');
    this.agentview = sessionStorage.getItem('agentview');
    this.page=sessionStorage.getItem('page')
   this.isFrench = ('fr-CA' === this.language) ? true : false; 
    const language = (window as any).mbfs.language;
    this.language= language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
  }

  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;
    
    if (this.selectedState === 1) {
      this.azURL =  this.usUrl + '/home/principalpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 2) {
      this.azURL =  this.usUrl + '/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 3) {
      this.azURL =  this.usUrl + '/home/statementpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 4) {
      this.azURL =  this.usUrl + '/home/bankprofile';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 6) {
      this.azURL =  this.usUrl + '/home/recurringpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 7) {
      this.azURL =  this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 8) {
      this.azURL =  this.usUrl + '/home/help';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    } 
  }

  onLoad(){
    this.dropDownList=[];
    const request = {
      "thirdPartyId" : this.thirdPartyNumber,
       "userId" : this.ciamId
    }
      this.auth.bankProfile(request).subscribe(res => {
       if(res.length==0){     
              sessionStorage.setItem('online-page-navigation', "Online-Payment")
              sessionStorage.setItem('userExist',"true")
              this.router.navigate(['/home/addprofile']);
            }else{
              sessionStorage.setItem('userExist',"false")
              this.profiles=res;
      
            this.profiles.forEach((element: any) => {
              let option=element.bankName+" "+element.maskedAccountNumber.substr(element.maskedAccountNumber.length - 4)
              let obj={selection: option, id:element.id}
              // if(element["saveProfile"]){
                this.dropDownList.push(obj);
              //   }
                this.selected=this.dropDownList[0]["id"];
            })
            this.cdr.detectChanges();
            this.bankDetailObj=this.profiles[0];
            this.bankDetailService.setObject(this.bankDetailObj);
            this.dtpayCustomerId = this.bankDetailObj.dtpay_customer_id;
            this.dtpayPaymentMethodToken = this.bankDetailObj.dtpay_payment_method_token;
            this.loaded=true;

            this.subscriptionsList();
          }
       
      }, error=>{ 
         if(error.status){
           this.loaded=true;
         }
    });
    }
 
    onChange(){
      let index=this.profiles.findIndex((obj:any)=>obj.id===this.selected)
      this.bankDetailObj=this.profiles[index];
      this.bankDetailService.setObject(this.bankDetailObj);
      this.dtpayCustomerId = this.bankDetailObj.dtpay_customer_id;
      this.dtpayPaymentMethodToken = this.bankDetailObj.dtpay_payment_method_token;
    }

    getSelectedBankName(): string {
      const selectedBank = this.dropDownList.find(opt => opt.id === this.selected);
      return selectedBank ? selectedBank.selection : '';  // Return the bank name or an empty string if not found
    }


  public disableCheckbox(): boolean {
    return this.selectionsingle.selected.length >= 1;
  }

  subscriptionsList() {
    const request = {
      "customer_id": this.dtpayCustomerId,
    };

    this.auth.subscriptionsList(request).subscribe(res => {
      let subscriptionList = res.data;

      this.subscriptionList = subscriptionList;
      console.log("getSubscriptions Response", this.subscriptionList);
      this.HistoricalSubscriptionDataSource = new MatTableDataSource(this.subscriptionList);
      this.HistoricalSubscriptionDataSource.sortingDataAccessor = (item: any, property: string) => {
        if (property === 'status') {
          switch (item.status?.toLowerCase()) {
            case 'active':
              return 1;
            case 'cancelled':   // ✅ match actual status value
              return 2;
            case 'expired':
              return 3;
            default:
              return 99;
          }
        }

        return (item as any)[property];
      };
      this.cdr.detectChanges();
      setTimeout(() => {
        this.HistoricalSubscriptionDataSource.paginator = this.paginator;
        this.HistoricalSubscriptionDataSource.sort = this.sort;
        this.rowCount = this.HistoricalSubscriptionDataSource.filteredData.length;
        this.sort.active = 'status';
        this.sort.direction = 'asc';
        this.sort.sortChange.emit();
      });
    });
  }


  applyStatusFilter(status: string) {

  if (!status) {
    // Reset filter if no status selected
    this.HistoricalSubscriptionDataSource.data = this.subscriptionList;
    return;
  }

  const filteredData = this.subscriptionList.filter(item => {
    if (status === 'active') {
      return item.status === 'ACTIVE';
    } else if (status === 'expired') {
      return item.status === 'EXPIRED';
    }else if (status === 'cancel') {
      return item.status === 'CANCELLED';
    }
    return true;
  });
   this.HistoricalSubscriptionDataSource.filter = status;
    if (this.HistoricalSubscriptionDataSource.paginator) {
      this.HistoricalSubscriptionDataSource.paginator.firstPage();
    }
    this.rowCount = this.HistoricalSubscriptionDataSource.filteredData.length;

}

  applyFilterAcc(input: string) {
    this.HistoricalSubscriptionDataSource.filterPredicate = (data: Daum, filter: string) => {
      if (!filter) return true;

      return data.line_items?.some(item =>
        item.description?.toLowerCase().includes(filter)
      );
    };

    input = input.trim().toLowerCase();
    this.HistoricalSubscriptionDataSource.filter = input;

    if (this.HistoricalSubscriptionDataSource.paginator) {
      this.HistoricalSubscriptionDataSource.paginator.firstPage();
    }

    this.rowCount = this.HistoricalSubscriptionDataSource.filteredData.length;
  }



  onDateRangeChange(event: any) {
    const range = this.selectedDateRange;

    if (!range?.start || !range?.end) {
      this.HistoricalSubscriptionDataSource.filter = '';
      return;
    }

    // Strip time from selected start and end dates
    const startDate = this.normalizeDate(range.start);
    const endDate = this.normalizeDate(range.end);

    this.HistoricalSubscriptionDataSource.filterPredicate = (data: Daum, filter: string) => {
      const exec = data.execution_interval;
      if (!exec || (!exec.start_date && !exec.end_date)) return false;

      const execStart = exec.start_date ? this.normalizeDate(new Date(exec.start_date)) : null;
      const execEnd = exec.end_date ? this.normalizeDate(new Date(exec.end_date)) : null;

      const isStartInRange = execStart && execStart >= startDate && execStart <= endDate;
      const isEndInRange = execEnd && execEnd >= startDate && execEnd <= endDate;

      return isStartInRange || isEndInRange;
    };

    this.HistoricalSubscriptionDataSource.filter = `${Math.random()}`;

    if (this.HistoricalSubscriptionDataSource.paginator) {
      this.HistoricalSubscriptionDataSource.paginator.firstPage();
    }

    this.rowCount = this.HistoricalSubscriptionDataSource.filteredData.length;
  }

  normalizeDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()); // sets time to 00:00:00
  }
 

  Remove(){
    this.checkToggleSelectedHis();
    const numSelected = this.selectionHis.selected.length;
    if (numSelected < 1 || numSelected > 1) {
      this.showerror = true;
    }else{
       this.Removepopup();
    }
   
  }

  isTerminateDisabled(): boolean {
    return this.selectionHis?.selected?.some(item =>
      ['expired', 'cancelled'].includes(item.status?.toLowerCase())
    );
  }

  Removepopup(){
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: {}  
    });
   
    dialogRef.afterClosed().subscribe(result => {
      if (result) {    
        
        this.tableLoaded = false;
        const numSelected = this.selectionHis.selected.length;
        const numRows = this.HistoricalSubscriptionDataSource.data.length;

        const selectedRows = this.selectionHis.selected;

        this.selectionHis.selected.forEach((row, index) => {
          this.Cancelid = row.id;
        });

        const request = {
          userId: this.ciamId,
          "id": this.Cancelid
        }

        this.auth.cancelSubscription(request).subscribe(res => {
          this.CancelSubscriptionData = [res];        
          console.log(this.CancelSubscriptionData);
          if (res) {
            this.tableLoaded = true;
            this.CancelSubscriptionSuccess = true;
            this.scheduledpayment = false;
          }
          this.CancelSubscriptionDataSource = new MatTableDataSource(this.CancelSubscriptionData);
          this.cdr.detectChanges();
          setTimeout(() => {
            this.CancelSubscriptionDataSource.paginator = this.paginator;
            this.CancelSubscriptionDataSource.sort = this.sort;
            this.rowCount = this.CancelSubscriptionDataSource.filteredData.length;
          });
        });
       
      }else{
        window.location.reload();
      }
    });
  }

  CancelledSubscription(){
   this._window.nativeWindow.location.href = '/home/dashboard';
  }

  checkToggleSelectedHis(){
    this.selectedHistoricalResponseList = [];
    for (var i = 0; i < this.selectionHis.selected.length; i++) {
     this.selectedHistoricalResponseList = this.selectionHis.selected;
    }
    this.HistoricalSubscriptionDataSource = new MatTableDataSource(this.selectedHistoricalResponseList);
    this.HistoricalSubscriptionDataSource.paginator = this.paginator;
    this.HistoricalSubscriptionDataSource.sort = this.sort;
    console.log(this.selectedHistoricalResponseList);
  }
}


@Component({
    selector: 'dialog-deletePopup',
    providers: [provideNativeDateAdapter()],
    imports: [
        MatPaginatorModule, MatSortModule, MatTableModule, MatCheckboxModule, MatFormFieldModule, MatDialogModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatButtonModule, MatSortModule,
        MatDialogContent, MatDialogActions, MatFormFieldModule, MatInputModule, MatDatepickerModule
    ],
    templateUrl: 'deleteprofilePopup.component.html'
})
export class DeleteDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ScheduledpaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any  
  ) { }

  onOk() {
    this.dialogRef.close(true);  
  }

 
  onCancel() {
    this.dialogRef.close(false); 
  }


}

